import(/* webpackMode: "eager" */ "/home/metha/İndirilenler/starbucksweb/src/app/not-found.tsx");
